import { axiosClientv1 } from "./apiClient";
import { ApiResponse } from "../Types";

export const GetSystemConfig = async (params?: {
  tenant_id?: string;
}): Promise<ApiResponse<any>> => {
  try {
    const response = await axiosClientv1.get(`/system-config`, { params });
    return response.data;
  } catch (error: any) {
    return {
      success: false,
      message:
        error?.response?.data?.message || "Failed to load system config.",
      data: {},
      error: {
        code: error?.response?.status || 500,
        type: "server_error",
      },
    };
  }
};

export const GetSystemConfigList = async (params?: {
  tenant_id?: string;
}): Promise<ApiResponse<any>> => {
  try {
    const response = await axiosClientv1.get(`/system-config/list`, { params });
    return response.data;
  } catch (error: any) {
    return {
      success: false,
      message:
        error?.response?.data?.message || "Failed to load system config list.",
      data: [],
      error: {
        code: error?.response?.status || 500,
        type: "server_error",
      },
    };
  }
};

export const CreateSystemConfig = async (
  payload: any,
): Promise<ApiResponse<any>> => {
  try {
    const response = await axiosClientv1.post(`/system-config/create`, payload);
    return response.data;
  } catch (error: any) {
    return {
      success: false,
      message:
        error?.response?.data?.message || "Failed to create system config.",
      error: {
        code: error?.response?.status || 400,
        type: "bad_request",
      },
    };
  }
};

export const UpdateSystemConfig = async (
  payload: any,
): Promise<ApiResponse<any>> => {
  try {
    const response = await axiosClientv1.post(`/system-config/update`, payload);
    return response.data;
  } catch (error: any) {
    return {
      success: false,
      message:
        error?.response?.data?.message || "Failed to update system config.",
      error: {
        code: error?.response?.status || 400,
        type: "bad_request",
      },
    };
  }
};

export const DeleteSystemConfig = async (
  id: string,
): Promise<ApiResponse<any>> => {
  try {
    const response = await axiosClientv1.post(`/system-config/delete`, { id });
    return response.data;
  } catch (error: any) {
    return {
      success: false,
      message:
        error?.response?.data?.message || "Failed to delete system config.",
      error: {
        code: error?.response?.status || 400,
        type: "bad_request",
      },
    };
  }
};
